const ACTION = {
    UPDATE_REGISTRATION_ADDRESS: 'UPDATE_REGISTRATION_ADDRESS',
    UPDATE_REGISTRATION_ADDRESS_ERROR_TEXT: 'UPDATE_REGISTRATION_ADDRESS_ERROR_TEXT',
}

export default ACTION;
